/**
 * Provides custom behaviour in the macro browser for the code macro.
 * The newcode-macro is loaded by macro browser. The only piece missing is the list of languages .
 */

import window from 'window-or-global';
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import { getPluginCodeLanguages } from '../utils/rest-api-editor';

const CodeMacroConfig = {
	fields: {
		string: {
			language: (param, options) => {
				const paramDiv = $(window.Confluence.Templates.MacroBrowser.macroParameterSelect());
				const input = $('select', paramDiv);

				// we need to do some trickery when the value is first set, and when the value is subsequently changed, so set this up.
				if (options == null) {
					options = {};
				}
				options.setValue = (value) => {
					const targetOption = input.find(`option[value='${value}']`);
					if (targetOption.length == 0) {
						const option = $('<option/>');
						option.val(value);
						option.text(value);
						input.append(option);
					}
				};

				bindAsyncDropDown(input);
				return new window.AJS.MacroBrowser.Field(paramDiv, input, options);
			},
		},
	},
};

/**
 * Populates an HTML Select element with the list of configured syntax highlighters.
 * @param dropDown JQuery selector for the HTML select element to be populated.
 */
function bindAsyncDropDown(dropDown) {
	// Load the languages from Confluence
	getPluginCodeLanguages((error, languages) => {
		if (error) {
			if (process.env.NODE_ENV !== 'production') {
				console.log('Error when fetching code macro languages', error);
			}
			return;
		} else if (!languages.length) {
			if (process.env.NODE_ENV !== 'production') {
				console.log('Configured code macro languages result was not in the expected format.');
			}
			return;
		}

		const currentValue = dropDown.val();

		dropDown.empty();
		dropDown.append($('<option/>').attr('value', ''));

		languages.forEach((lang) => {
			const option = $('<option />');
			option.val(lang.aliases[0]);
			option.text(lang.friendlyName);
			dropDown.append(option);
		});

		// restore the currently selected value.
		dropDown.val(currentValue);
	});
}

export function exportGlobalCodeMacroConfig() {
	window.AJS.MacroBrowser.Macros['code'] = CodeMacroConfig;
}

export function exportGlobalCodeMacroConfigWRM() {
	return [
		// Already present: confluence.editor.actions:editor-macro-browser
		'wr!confluence.web.resources:quicksearchdropdown',
	];
}
